App.controller('setupCtrl', ($scope, $stateParams, Perm, FeatureFlag, $state, $rootScope, toaster) => {
  $scope.payments_setup_tab = false
  $scope.online_booking_setup_tab = false
  $scope.waitlist_setup_tab = false
  $scope.subscribed_to_communications = false
  $scope.subscribed_to_forms = false

  $scope.$on("loc_change", () => {
    setUpAccess()
  })

  Perm.perm_promise.then(() => {
    setUpAccess()
  })

  setUpAccess = () => {
    if (Perm.can_access_tab('availability') && !Perm.can_access_tab('setup')) {
      $scope.redirectUnlessCanAccessTab('availability')
    } else {
      $scope.redirectUnlessCanAccessTab('setup')
    }

    const {
      subscribed_to_messaging,
      subscribed_to_campaigns,
      subscribed_to_reminders,
      subscribed_to_recalls,
      subscribed_to_reviews,
      subscribed_to_waitlist,
      subscribed_to_online_booking,
      subscribed_to_forms,
      subscribed_to_payments
    } = $rootScope.location.privileges

    $scope.online_booking_setup_tab = subscribed_to_online_booking
    $scope.waitlist_setup_tab = subscribed_to_waitlist
    $scope.subscribed_to_communications = subscribed_to_messaging ||
                                          subscribed_to_campaigns ||
                                          subscribed_to_reminders ||
                                          subscribed_to_recalls ||
                                          subscribed_to_reviews
    $scope.subscribed_to_forms = subscribed_to_forms
    $scope.appointment_types_setup_tab = $scope.online_booking_setup_tab ||
                                         $scope.waitlist_setup_tab ||
                                         $scope.subscribed_to_communications ||
                                         $scope.subscribed_to_forms ||
                                         $rootScope.institution.is_api_only ||
                                         $rootScope.embedded
    $scope.availability_setup_tab = $scope.online_booking_setup_tab ||
                                    $scope.waitlist_setup_tab ||
                                    $rootScope.institution.is_api_only ||
                                    $rootScope.embedded

    FeatureFlag.$find('availabilities_setup_redesign').$then((ff) => {
      $scope.availabilities_setup_redesign = ff.availabilities_setup_redesign
    })

    $scope.payments_setup_tab = subscribed_to_payments

    if ($rootScope.embedded) {
      $scope.checkPageAccess()
    } else {
      redirectionPage = $scope.redirectionPage()
    }
    if (redirectionPage) {
      $state.go(redirectionPage, $stateParams, { reload: true })
    }
  }

  $scope.showMigratedPages = () => {
    switch($state.current.name) {
      case 'app.settings.personal':
      case 'app.settings.notifications':
      case 'app.setup.logo':
      case 'app.setup.synchronizer':
      case 'app.setup.permissions':
      case 'app.setup.users':
      case 'app.setup.users.invite':
      case 'app.setup.sms-registration':
      case 'app.setup.access':
      case 'app.setup.insights':
      case 'app.setup.templates':
      case 'app.setup.automations':
      case 'app.setup.translations':
      case 'app.setup.translations.languages':
      case 'app.setup.waitlist':
      case 'app.setup.payments':
      case 'app.setup.payment-registrations':
      case 'app.setup.payment-configurations':
      case 'app.setup.payment-processing-fees':
      case 'app.setup.payment-plans':
      case 'app.setup.smart_commands':
      case 'app.setup.partner_integrations':
      case 'app.setup.online_booking_links':
      case 'app.setup.eligibility-report-sync':
      case 'app.setup.blocked-insurance-payers':
      case 'app.setup.insurance-verification-window':
      case 'app.setup.insurance-verification-configuration':
      case 'app.setup.insurance-portal-credentials':
      case 'app.setup.insurance-usage-management':
      case 'app.setup.messages':
      case 'app.setup.coworker':
      case 'app.setup.coworker.test_drive':
      case 'app.setup.phone-connection':
      case 'app.setup.appointment_types.mappings':
      case 'app.setup.availability.advanced':
      case 'app.setup.availability.edit':
      case 'app.setup.availability.edit.single':
      case 'app.setup.forms_settings':
      case 'app.setup.appointment_types':
      case 'app.setup.insurances':
      case 'app.setup.online_booking_form':
        return true
      case 'app.setup.availability':
        return $scope.availabilities_setup_redesign
      default:
        return false
    }
  }

  $scope.redirectionPage = () => {
    const page = 'app.setup.logo'

    switch($state.current.name) {
      case 'app.setup':
        return page
      case 'app.setup.waitlist':
        if (!$scope.waitlist_setup_tab) {
          return page
        }
        break
      case 'app.setup.payments':
        if (!$scope.payments_setup_tab) {
          return page
        }
        break
      case 'app.setup.insurances':
      case 'app.setup.online_booking_form':
        if (!$scope.online_booking_setup_tab) {
          return page
        }
        break
      case 'app.setup.availability':
        if (!$scope.availability_setup_tab) {
          return page
        }
        break
      case 'app.setup.appointment_types':
        if (!$scope.appointment_types_setup_tab) {
          return page
        }
        break
      case 'app.setup.appointment_type_mappings':
        if (!$scope.online_booking_setup_tab && !$scope.waitlist_setup_tab && !$scope.subscribed_to_communications && !$scope.subscribed_to_forms) {
          return page
        }
        break
      default:
        break
    }
  }

  $scope.checkPageAccess = () => {
    if ($state.current.name === 'app.setup.availability' && !$scope.availability_setup_tab) {
      toaster.pop('error', 'Error', "Availability settings are not enabled" );
    }

    if ($state.current.name === 'app.setup.appointment_types' && !$scope.appointment_types_setup_tab) {
      toaster.pop('error', 'Error', "Appointment types settings ane not enabled" );
    }
  }
})
